<template>
  <b-modal id="ModalCnae" hide-footer>
    <Header titulo="CNAEs" :close="closeModal" slot="modal-header" />
    <div class="modal-lista-cnae" v-for="(item, index) in cnaes" :key="index">
      <div>
        {{ item.cnae.codigo }}
      </div>
      <div class="modal-lista-cnae-descricao">
        {{ item.cnae.descricao }}
      </div>
    </div>
  </b-modal>
</template>

<script>
import Header from "@/components/ModalComponente/Header.vue";

export default {
  name: "ModalCnae",
  components: {
    Header
  },
  props: {
    cnaes: Array
  },
  methods: {
    closeModal() {
      this.$root.$emit("bv::hide::modal", "ModalCnae");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-lista-cnae {
  display: grid;
  grid-template-columns: 2fr 5fr;
  padding: 5px 0;
  font-size: 12px;
  color: var(--cinza3);
  // background: var(--cinza01);
  > div {
    display: flex;
    justify-content: center;
  }
  .modal-lista-cnae-descricao {
    justify-content: flex-start;
    padding-right: 10px;
  }
  &:nth-child(even) {
    background: var(--cinza0);
  }
}
</style>
